export const GUARDAR_SESION = "GUARDAR_SESION";
export const BORRAR_SESION = "BORRAR_SESION";